import { useState, useEffect, useRef } from "react";
import { FaTimes, FaReply, FaPencilAlt, FaRegTrashAlt, FaFileAlt } from "react-icons/fa";
import CommentBox from "./commments/CommentBox";
import { Button } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import { toastError, toastSuccess } from '../toaster';
import pathconfig from '../../pathconfig.json';
import packjson from '../../../package.json';
import axios from "axios";
import { useAppContextProvider } from '../../contextapi';

const generateUniqueId = () => {
  return uuidv4().slice(0, 3); // Generate a 3-letter unique ID
};
const handleError = (error, message = error || 'Something went wrong') => {
  console.error(error);
  toastError(message);
};
const CommentTab = (props) => {
  const [comments, setComments] = useState([]);
  const [commentsAll, setCommentsAll] = useState([]);
  const [replyingIndex, setReplyingIndex] = useState(null);
  const [replyText, setReplyText] = useState('');
  const [repliedComments, setRepliedComments] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedCommentText, setEditedCommentText] = useState('');
  const [editingReplyIndex, setEditingReplyIndex] = useState(null); // { commentIndex, replyIndex }
  const [editedReplyText, setEditedReplyText] = useState('');
  const [showconfirm, setConfirm] = useState(false)
  const [deleteValue, setDeleteValue] = useState({})
  const { userProfile, setLineFocus, viewDoc, commentValue, setCommentValue, commentSidebar, setCommentDelete, trackfileComment, setSidebarClose } = useAppContextProvider();
  const [isEditing, setIsEditing] = useState(false);
  const [commentProgress, setCommentProgress] = useState(false)
  const closeBtnRef = useRef(null); 
  const yesBtnRef = useRef(null);

  useEffect(() => {
    if (showconfirm && yesBtnRef.current) {
      yesBtnRef.current.focus();
    }
  }, [showconfirm]);

  useEffect(() => {
    if (closeBtnRef.current) {
      closeBtnRef.current.focus();
    }
  }, []);

  const [highlightedComment, setHighlightedComment] = useState(null);
  const commentRefs = useRef({});

  //just for testing build
  useEffect(() => {
    const hasCommentsChanged = (prevComments, newComments) => {
      // Implement a deep comparison logic here
      return JSON.stringify(prevComments) !== JSON.stringify(newComments);
    };
    if (hasCommentsChanged(commentValue.comment, comments)) {
      // let commentAdded =comments.map((item) => item.ActivityID === undefined ? props.isDocvalue.ActivityID : item.ActivityID);
      let CommentsChange = { comment: comments, changeIndex: null }
      setCommentValue(CommentsChange);
    }
  }, [comments, commentValue.comment]);

  // useEffect(() => {
  //   if (commentBlob.length > 0) {
  //     const filterBlob = commentBlob.filter(item => item?.comment !== '')
  //     const filterFromComment = filterBlob.filter((itemB) =>
  //       comments.some((itemC) => itemC.cid === itemB.cid)
  //     )
  //     setCommentRange(filterFromComment);
  //   }
  // }, [commentBlob]);

  useEffect(() => {
    if (commentValue?.comment !== undefined && commentValue?.comment.length > 0) {
      setComments(commentValue?.comment);
      setCommentsAll(commentValue?.comment);
      // setCommentBlob(commentValue)
    }
  }, [commentValue]);

  // export const CommentUpdateFunction = (value) => {
  //   // Ensure `updatedComments` excludes undefined or invalid results
  //   console.log(value, 'value')
  //   const updatedComments = props.changedComment
  //     .filter((itemA) => itemA !== undefined) // Filter out undefined items
  //     .map((itemA) => {
  //       const matchingBlob = comments.find((itemB) => itemB.cid === itemA.cid);
  //       if (matchingBlob) {
  //         return {
  //           ...matchingBlob,
  //           ActivityID: matchingBlob.ActivityID,
  //           Attachments: matchingBlob.Attachments,
  //           Cmdcomtents: matchingBlob.Cmdcomtents,
  //           Date_Time: matchingBlob.Date_Time,
  //           NoActionRequired: matchingBlob.NoActionRequired,
  //           ReplyRequire: matchingBlob.ReplyRequire,
  //           Username: matchingBlob.Username,
  //           cid: matchingBlob.cid,
  //           cmdtype: matchingBlob.cmdtype,
  //           "element-type": "Comments",
  //           from: itemA.from,
  //           isTrack: false,
  //           linenumber: viewDoc?.state.doc.lineAt(itemA.from)?.number || 0, // Safely access viewDoc
  //           orderid: matchingBlob.orderid,
  //           reply: matchingBlob.reply,
  //           role: matchingBlob.role,
  //           selectText: matchingBlob.selectText,
  //           sequencenumber: "",
  //           status: "",
  //           to: itemA.to,
  //           trackType: matchingBlob.trackType,
  //         };
  //       }
  //       return null; // Return null if no matchingBlob found
  //     })
  //     .filter((comment) => comment !== null); // Exclude null values

  //   // Prepare the final object for the updated comments
  //   const CommentsChange = { comment: updatedComments, changeIndex: null };

  //   // Update the state with the changed comments
  //   setChangedComment(CommentsChange);

  //   // Log the result for debugging
  //   console.log(CommentsChange, 'CommentsChange');
  // };

  // useEffect(() => {
  //     if (props?.isCommentValue.length !== 0) {
  //         setCommentBlob(props?.isCommentValue)
  //     }
  // }, [props?.isCommentValue])

  // useEffect(() => {
  //   if (Object.keys(commentRange).length !== 0 && comments.length > 0) {
  //     const updatedComments = commentRange.map((itemA) => {
  //       const matchingBlob = commentRange.find((itemB) => itemB.cid === itemA.cid);
  //       return matchingBlob
  //         ? {
  //           ...itemA,
  //           from: matchingBlob.from,
  //           to: matchingBlob.to,
  //           linenumber: viewDoc.state.doc.lineAt(matchingBlob.from).number,
  //         }
  //         : itemA;
  //     });
  //     // Check if the comments have actually changed before updating the state
  //     if (JSON.stringify(comments) !== JSON.stringify(updatedComments)) {
  //       setComments(updatedComments);
  //       setCommentsAll(updatedComments);
  //     }
  //   }
  // }, [commentRange]);

const highlightComment = (comment) => {
  setHighlightedComment(comment);
  const refKey = `${comment.cid || comment.id || comment.Username}-${comment.from}-${comment.to}`;
  if (comment && commentRefs.current[refKey]) {
    const element = commentRefs.current[refKey];
    const rect = element.getBoundingClientRect();
    const container = element.closest('.comment-group');
    if (container) {
      const containerRect = container.getBoundingClientRect();
      const isVisible = rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;
      if (!isVisible) {
        if (rect.top < containerRect.top) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (rect.bottom > containerRect.bottom) {
          element.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
      }
    }
  }
};

  // Global click handler for editor-to-sidebar navigation (like trackchanges)
  useEffect(() => {
    const handleEditorCommentClick = (event) => {
      // Use .ol-cm-change-c for comment markers
      const commentElement = event.target.closest('.ol-cm-change-c');
      if (commentElement) {
        // Extract attributes from the clicked editor marker
        const from = commentElement.getAttribute('data-from') || commentElement.parentElement?.getAttribute('data-from');
        const to = commentElement.getAttribute('data-to') || commentElement.parentElement?.getAttribute('data-to');
        const user = commentElement.getAttribute('data-user') || commentElement.parentElement?.getAttribute('data-user');
        // Find the matching comment in the sidebar data
        if (from && to && user) {
          // Try strict match first
          let matchingComment = commentsAll.find(
            (item) =>
              String(item.from) === String(from) &&
              String(item.to) === String(to) &&
              item.Username === user 
          );
          // Fallback: match only from/to/Username if role is empty
          if (!matchingComment) {
            matchingComment = commentsAll.find(
              (item) =>
                String(item.from) === String(from) &&
                String(item.to) === String(to) &&
                item.Username === user
            );
          }
          if (matchingComment) {
            // setHighlightedComment(matchingComment);
            highlightComment(matchingComment);
          }
        }
      }
    };
    document.addEventListener('click', handleEditorCommentClick);

    // Existing outside click logic to clear highlight
    const handleOutsideClick = (event) => {
      const isEditorChange = event.target.closest('.ol-cm-change-i, .ol-cm-change-d');
      const isSidebarComment = event.target.closest('.comment-inner');
      if (!isEditorChange && !isSidebarComment && highlightedComment) {
        setHighlightedComment(null);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleEditorCommentClick);
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [highlightedComment, commentsAll]);

  const handleSaveComment = (commentText) => {
    try {
      if (commentSidebar?.selectValue.selectText !== '') {
        if (commentText) {
          const comment = {
            Username: userProfile.username, // Replace with actual username
            role: userProfile.role,
            ActivityID: userProfile.ActivityID,
            cid: generateUniqueId(), // Generate a unique ID for the comment
            Date_Time: new Date().toLocaleString(),
            Cmdcomtents: commentText.comment,
            reply: [], // Initialize reply as an empty array
            Attachments: commentText.fileattached,
            ReplyRequire: false,
            status: '',
            isTrack: false,
            trackType: 'none',
            'element-type': 'Comments',
            cmdtype: 'Comments',
            orderid: 1,
            NoActionRequired: false,
            sequencenumber: '',
            linenumber: commentSidebar?.selectValue.linenumber,
            selectText: commentSidebar?.selectValue.selectText,
            from: commentSidebar?.selectValue.fromLine,
            to: commentSidebar?.selectValue.toLine,
          };
          setComments([...comments, comment]);
          setCommentsAll([...comments, comment])
          // setLineFocus(comment);
        }
      } else {
        toastError('Please select a word or text to insert a comment..')
      }
    } catch (error) {
      handleError(error, 'Error saving comment');
    }
  };

  const handleConfirmDelete = (e, index, replyIndex = null) => {
    setDeleteValue({ 'index': index, 'replyValue': replyIndex })
    setConfirm(true)
  }

  const handleDeleteComment = () => {
    try {
      const updatedComments = comments.filter((comment, index) => {
        if (index === deleteValue.index) {
          if (deleteValue.replyValue === null) {
            // Deleting a main comment
            return false; // Remove this comment
          } else {
            // Deleting a reply
            comment.reply = comment.reply.filter((_, replyIndex) => replyIndex !== deleteValue.replyValue);
            return true; // Keep the main comment, but with updated replies
          }
        }
        return true;
        // Keep all other comments
      });
      const deletedComment = deleteValue.replyValue === null
        ? comments[deleteValue.index]
        : comments[deleteValue.index].reply[deleteValue.replyValue];
      setComments(updatedComments);
      setCommentsAll(updatedComments);
      setCommentDelete(deletedComment);
      setConfirm(false);
      toastSuccess('Message deleted successfully.');
    } catch (error) {
      handleError(error, 'Error deleting comment');
    }
  };

  const handleReplyButtonClick = (e, index) => {
    e.stopPropagation()
    setReplyingIndex(index);
    setReplyText('');
  };

  const handleSendReply = (commentData, commentIndex) => {
    try {
      const cleanupReplycomment = commentData.comment
        // .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, "");

      if (!cleanupReplycomment.trim()) {
        toastError('Reply cannot be empty');
        return;
      }

      const reply = {
        Username: userProfile.username, // Replace with actual username
        role: userProfile.role,
        ActivityID: userProfile.ActivityID,
        Date: new Date().toLocaleDateString(),
        Time: new Date().toLocaleTimeString(),
        rpid: generateUniqueId(), // Generate a unique ID for the reply
        Date_Time: new Date().toLocaleString(),
        rplycomtents: cleanupReplycomment,
        newcmnd: true,
        status: '',
        sequencenumber: '',
        cmdtype: 'ReplyCmnt',
        orderid: 1,
        id: comments[commentIndex].cid,
        NoActionRequired: false,
        category: commentData.category || '',
      };
      const updatedComments = [...comments];
      // Convert empty object to array if needed
      updatedComments[commentIndex].reply = Array.isArray(updatedComments[commentIndex].reply)
        ? updatedComments[commentIndex].reply
        : [];

      updatedComments[commentIndex].reply.push(reply);
      updatedComments[commentIndex].Date = new Date().toLocaleDateString(); // Update Date
      updatedComments[commentIndex].Date_Time = new Date().toLocaleString(); // Update Date_Time
      setComments(updatedComments);
      setCommentsAll(updatedComments);
      setReplyingIndex(null)
      setReplyText('');
      setRepliedComments({ ...repliedComments, [commentIndex]: true });
      setTimeout(() => {
        let CommentsChange = { comment: comments, changeIndex: commentIndex }
        setCommentValue(CommentsChange);
      }, 1000);
    } catch (error) {
      handleError(error, 'Error sending reply');
    }
  };

  const handleCommentClick = (commentId) => {
    setLineFocus(commentId);
    highlightComment(commentId);
  };

  const handleEditComment = (e, index) => {
    e.stopPropagation();
    const commentToEdit = comments[index];
    setEditingIndex(index);
    // Ensure we're setting the exact content from the comment
    setEditedCommentText(commentToEdit.Cmdcomtents);
    setIsEditing(true);
    console.log("Editing comment:", commentToEdit.Cmdcomtents); // Debug log
  };

  const handleEditReply = (e, commentIndex, replyIndex) => {
    e.stopPropagation();
    const replyToEdit = comments[commentIndex].reply[replyIndex];
    setEditingReplyIndex({ commentIndex, replyIndex });
    setEditedReplyText(replyToEdit.rplycomtents);
  };

  const handleSaveEditedReply = (commentData, commentIndex, replyIndex) => {
    try {
      const cleanupReplyComment = commentData.comment
        .replace(/&nbsp;/g, " ")
        .trim();

      const hasContent = cleanupReplyComment.replace(/<[^>]*>/g, "").trim().length > 0;
      if (!hasContent) {
        toastError('Reply cannot be empty');
        return;
      }

      const updatedComments = [...comments];
      updatedComments[commentIndex].reply[replyIndex].rplycomtents = cleanupReplyComment;
      if (commentData.category !== undefined) {
        updatedComments[commentIndex].reply[replyIndex].category = commentData.category || '';
      }
      updatedComments[commentIndex].reply[replyIndex].Date_Time = new Date().toLocaleString();
      updatedComments[commentIndex].reply[replyIndex].Date = new Date().toLocaleDateString();
      updatedComments[commentIndex].reply[replyIndex].Time = new Date().toLocaleTimeString();
      setComments(updatedComments);
      setCommentsAll(updatedComments);
      setEditingReplyIndex(null);
      setEditedReplyText('');
    } catch (error) {
      handleError(error, 'Error editing reply');
    }
  };

  const deleteConfirm = (value, indexvalue) => {
    try {
      props.getTrigger(false)
      let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
      let GetDetailData = JSON.parse(GetDetailDataString);
      let data = {
        "ArticleGUID": value.ArticleGUID,
        "AttachID": value.AttachID,
        "Proof_Type": GetDetailData.jobdetails.ProofType,
        "AttachFlag": value.AttachFlag,
        "docid": userProfile.docid
      }
      const deleteUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].deleteAttachment}`;
      axios.post(deleteUrl, data).then((response) => {
        toastSuccess(`${response.data.data[0].Filename} - ${response.data.message}`)
        props.getTrigger(true)
        props.refreshAttachments();
      }
      ).catch((error) => {
        console.log(error);
        toastError(error.message);
        //navigate(`/notification?docid=${profile.docid}`, { state: 'error' })
      });
      const attachmentDelete = [...comments];
      attachmentDelete[indexvalue].Attachments = [];
      setComments(attachmentDelete);
      setCommentsAll(attachmentDelete);
    } catch (error) {
      handleError(error, 'Error confirming deletion');
      props.getTrigger(true);
    }
  }

  const getTriggerfile = () => {
    // props.getTrigger(true)
    props.refreshAttachments(true);
  }

  const handleSelect = (e) => {
    try {
      if (e.target.value === 'all') {
        setCommentsAll(comments)
      } else {
        let filter = comments.filter((item) => item.role === e.target.value)
        setCommentsAll(filter)
      }
    } catch (error) {
      handleError(error, 'Error filtering comments');
    }
  }

  useEffect(() => {
    if (trackfileComment.length !== 0) {
      setComments(trackfileComment);
      setCommentsAll(trackfileComment)
    }
  }, [trackfileComment]);

  const fileProgress = (value) => {
    setCommentProgress(value)
  }
  
  return (
    <div className="comment-area commenttab">
      <header className="slider-header">
        <h2>Comment - ({commentsAll.length})</h2>
        <button
          className="close-btn"
          title="Close"
          tabIndex={0}
          ref={closeBtnRef}
          onClick={() => {
            setSidebarClose(true);
            setTimeout(() => {
              const commentTab = document.getElementById('comment-tab-btn');
              if (commentTab) commentTab.focus();
            }, 0);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setSidebarClose(true);
              setTimeout(() => {
                const commentTab = document.getElementById('comment-tab-btn');
                if (commentTab) commentTab.focus();
              }, 0);
            }
          }}
        >
          <FaTimes />
        </button>
      </header>
      <div className={`modal-outer ${showconfirm ? 'active' : ''}`} role="dialog" aria-modal="true" aria-labelledby="modal-title" aria-describedby="modal-description">
        <div className="modal confirmation-popup">
          <div className="modal-header">
            <h1 id="modal-title">Confirm Delete</h1>
            <button className="modal-close-btn" tabIndex={0} aria-label="Close" onClick={() => setConfirm(false)}><FaTimes /></button>
          </div>
          <div className="modal-body">
            <p style={{ textAlign: 'center', margin: '10px 0' }}>Are you sure you want to delete this comment?</p>
          </div>
          <div className="modal-footer">
            <button
              className="primary"
              tabIndex={0}
              ref={yesBtnRef}
              onClick={handleDeleteComment}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') handleDeleteComment();
              }}
            >
              Yes
            </button>
            <button
              className="outline-secondary"
              tabIndex={0}
              onClick={() => setConfirm(false)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') setConfirm(false);
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
      <div className={`modal-outer ${commentProgress ? 'active' : ''}`} role="alertdialog" aria-modal="true">
        <div className="modal confirmation-popup">
          <div className="modal-header">
            <h1>Uploading</h1>
          </div>
          <div className="modal-body">
            <p>Uploading file... Please wait while we save your comment.</p>
            <span className="loader"></span>
          </div>
        </div>
      </div>
      <main className="comment-group" aria-label="comments header">
        <section className="comment-note">
          <FaFileAlt /> <p>Note: Please select a word or text to insert a comment</p>
        </section>
        <CommentBox onSaveComment={handleSaveComment} onCancelComment={() => setReplyingIndex(null)} getTriggerfile={getTriggerfile} fileProgress={fileProgress} refreshAttachments={props.refreshAttachments} />
        <section className="filterTop" style={{ marginTop: '10px' }}>
          <label>Filter:</label>
            <select aria-label="Default select example" tabIndex={0} onChange={(e) => handleSelect(e)}>
            <option value="all">All</option>
            <option value="Author">Author</option>
            <option value="Editor">Editor</option>
            <option value="Master Copier">Master Copier</option>
            <option value="Copy Editor">Copy Editor</option>
          </select>
          {/* Add Tab handler for Filter dropdown if no comments */}
          {commentsAll.length === 0 && (
            <script>
              {`
                document.querySelector('[aria-label="Default select example"]').addEventListener('keydown', function(e) {
                  if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    setTimeout(function() {
                      var downloadBtn = document.querySelector('.fourthstep');
                      if (downloadBtn) downloadBtn.focus();
                    }, 0);
                  }
                });
              `}
            </script>
          )}
        </section>
        <section className="comment-container">
          {commentsAll.length > 0 && commentsAll.map((comment, index) => {
            const attachmentContent = Array.isArray(comment?.Attachments) && comment?.Attachments?.length > 0 ? (
              <div className='comment-attached' style={{ marginTop: '6px' }}>
                {comment.Attachments.map((item, attachmentIndex) => (
                    <div className='comment-attached-list' key={`attachment-${index}-${attachmentIndex}`}>
                      <p title={item.Filename}>{item.Filename}</p>
                      <label>size - {item.Filesize}</label>
                      { userProfile.role === JSON.parse(item.Rolename)[0].RoleName ?(
                        <button tabIndex={0} onClick={() => deleteConfirm(item, index)} onKeyDown={(e) => e.key === 'Enter' && deleteConfirm(item, index)}><FaRegTrashAlt /></button>
                      ) : null}
                    </div>
                ))}
              </div>
            ) : null
                  const refKey = `${comment.cid || comment.id || comment.Username}-${comment.from}-${comment.to}`;
                  const isHighlighted = highlightedComment &&
                    ((highlightedComment.cid && highlightedComment.cid === comment.cid) ||
                    (highlightedComment.id && highlightedComment.id === comment.id)) &&
                    highlightedComment.from === comment.from &&
                    highlightedComment.to === comment.to;
                              return (
                                <article
                                  key={`comment-${index}`}
                                  className="comment-display"
                                >
                                <div
                    className={`comment-inner${isHighlighted ? ' highlighted' : ''}`}
                    ref={el => (commentRefs.current[refKey] = el)}
                  >
                  <div
                    onClick={() => handleCommentClick(comment)}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      handleCommentClick(comment)
                    }
                    tabIndex={0}
                    role="button"
                  >
                    <h3>{comment.Username}{" "}</h3>
                    <label className="time-label">{comment.Date_Time}</label>
                    {editingIndex === index ? (
                      <div onClick={(e) => e.stopPropagation()}>
                        <CommentBox
                          onSaveComment={(commentData) => {
                            const cleanupEditComment = commentData.comment
                              .replace(/<(?!\/?(b|i|u|strong|em))[^>]*>/g, "")
                              .replace(/&nbsp;/g, " ")
                              .trim();

                            // Check if comment has actual content after cleaning
                            const hasContent = cleanupEditComment.replace(/<[^>]*>/g, "").trim().length > 0;

                            if (!hasContent) {
                              toastError('Comment cannot be empty');
                              return;
                            }

                            const updatedComments = [...comments];
                            updatedComments[index].Cmdcomtents = cleanupEditComment;
                            updatedComments[index].Attachments = commentData.fileattached;
                            updatedComments[index].Date = new Date().toLocaleDateString();
                            updatedComments[index].Date_Time = new Date().toLocaleString();
                            setComments(updatedComments);
                            setCommentsAll(updatedComments);
                            setEditingIndex(null);
                            setIsEditing(false);
                          }}
                          onCancelComment={() => {
                            setEditingIndex(null);
                            setIsEditing(false);
                          }}
                          getTriggerfile={getTriggerfile}
                          initialContent={editedCommentText} // Add this prop
                          commentAttach={comment.Attachments}
                          fileProgress={fileProgress}
                        />
                      </div>
                    ) : (
                      <p 
                        aria-label={`Comment: ${comment.Cmdcomtents}`}
                        role="article"
                        tabIndex={0}
                        dangerouslySetInnerHTML={{
                          __html: comment.Cmdcomtents,
                        }}
                      ></p>
                    )}

                    {attachmentContent}
                  </div>
                  {editingIndex !== index && (
                    <div className="comment-footer">
                      {/* Only show Edit buttons for the comment owner */}
                        {comment.role === userProfile.role && (
                          <Button tabIndex={0} onClick={(e) => handleEditComment(e, index)} className="accept-btn" title="Edit" > <FaPencilAlt /> Edit </Button>
                        )}

                        {/* Show reply button only if comment is not from current user and no reply from current role exists */}
                        {comment.role !== userProfile.role &&
                          !comment.reply?.some(r => r.role === userProfile.role) && (
                          <Button tabIndex={0} onClick={(e) => handleReplyButtonClick(e, index)} className="accept-btn" title="Reply"> <FaReply /> Reply </Button>
                        )}

                        {/* Only show Delete buttons for the comment owner */}
                        {comment.role === userProfile.role && (
                          <Button
                            tabIndex={0}
                            onClick={(e) => handleConfirmDelete(e, index)}
                            className="reject-btn"
                            title="Delete"
                            onKeyDown={
                              index === commentsAll.length - 1
                                ? (e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                      e.preventDefault();
                                      setTimeout(() => {
                                        let downloadBtn;
                                        if (userProfile.role === "Master Copier") {
                                          downloadBtn = document.querySelector('button[title="TrackChangeFile.tex download"]');
                                        } else {
                                          downloadBtn = document.querySelector('.fourthstep');
                                        }
                                        if (downloadBtn) downloadBtn.focus();
                                      }, 0);
                                    }
                                  }
                                : undefined
                            }>
                            <FaRegTrashAlt /> Delete
                          </Button>
                        )}
                    </div>
                  )}
                  {comment.reply && comment.reply.length > 0 && (
                    <div className="comment-inner reply-area">
                      {comment.reply.map((reply, replyIndex) => {
                        const displayText =
                          userProfile.role === 'Master Copier' && reply.category
                            ? `Reply to ${reply.category}: ${reply.rplycomtents}`
                            : `Reply: ${reply.rplycomtents}`;
                        const isEditingThisReply =
                          editingReplyIndex &&
                          editingReplyIndex.commentIndex === index &&
                          editingReplyIndex.replyIndex === replyIndex;
                        return (
                          <div key={`reply-${index}-${replyIndex}`} className="reply-inner">
                            <h3>{reply.Username}{" "}</h3>
                            <label className="time-label">{reply.Date_Time || comment.Date_Time}</label>
                            {isEditingThisReply ? (
                              <div onClick={(e) => e.stopPropagation()}>
                                <CommentBox
                                  onSaveComment={(commentData) => {
                                    handleSaveEditedReply(commentData, index, replyIndex);
                                  }}
                                  onCancelComment={() => {
                                    setEditingReplyIndex(null);
                                    setEditedReplyText('');
                                  }}
                                  getTriggerfile={getTriggerfile}
                                  initialContent={editedReplyText}
                                  isReply={true}
                                  showCategory={true}
                                  initialCategory={reply.category}
                                />
                              </div>
                            ) : (
                              <p
                                aria-label={displayText}
                                role="article"
                                tabIndex={0}
                                dangerouslySetInnerHTML={{ __html: displayText }}
                              ></p>
                            )}
                            {!isEditingThisReply && (
                              <div className="comment-footer">
                                {/* Edit button - visible only to the reply author */}
                                {reply.role === userProfile.role && (
                                  <Button
                                    tabIndex={0}
                                    onClick={(e) => handleEditReply(e, index, replyIndex)}
                                    className="accept-btn"
                                    title="Edit"
                                  >
                                    <FaPencilAlt /> Edit
                                  </Button>
                                )}
                                {/* Delete button - visible only to the reply author */}
                                {reply.role === userProfile.role && (
                                  <Button
                                    tabIndex={0}
                                    onClick={(e) =>
                                      handleConfirmDelete(e, index, replyIndex)
                                    }
                                    className="reject-btn"
                                    title="Delete"
                                  >
                                    <FaRegTrashAlt /> Delete
                                  </Button>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {replyingIndex === index && (
                    <div className="reply-area">
                      <CommentBox
                        onSaveComment={(commentData) => {
                          handleSendReply(commentData, index);
                          setReplyingIndex(null);
                        }}
                        onCancelComment={() =>
                          setReplyingIndex(null)
                        }
                        getTriggerfile={getTriggerfile}
                        isReply={true}  // Add this prop
                        showCategory={true}
                      />
                    </div>
                  )}
                </div>
              </article>
            );
          })}
        </section>
      </main>
    </div>
  )
}
export default CommentTab;